import axios from 'axios';

export const GET_STREAMING = '[STREAMING] GET LIVE STREAMING';
export const GET_CATEGORIES = '[STREAMING] GET CATEGORIES';

export function getStreaming() {
	const request = axios.get('/api/streaming/get');
	
	return dispatch =>
		request.then(response =>
			dispatch({
				type: GET_STREAMING,
				payload: response.data
			})
		);
}

export function getCategories() {
	const request = axios.get('/api/projects/get');

	return dispatch =>
		request.then(response =>
			dispatch({
				type: GET_CATEGORIES,
				payload: response.data
			})
		);
}
